// extracted by mini-css-extract-plugin
export default {"standing":"Name_standing__67QLv","hidden":"Name_hidden__3--KJ","visible":"Name_visible__2cyLt","points":"Name_points__lhODh"};